import { CircleCheck, CircleX } from "lucide-react";
import React from "react";
import { Group } from "@mantine/core";
import DownloadEmployeeDataFileActionIcon from "./DownloadEmployeeDataFileActionIcon";
import CancelEmployeeImportActionIcon from "./CancelEmployeeImportActionIcon";
import ImportEmployeeDataActionIcon from "./ImportEmployeeDataActionIcon";

type EmployeeDataImportTableMenuProps = {
  id: number;
  status: string;
};

const EmployeeDataImportTableMenu: React.FC<
  EmployeeDataImportTableMenuProps
> = ({ id, status }) => (
  <Group spacing="md">
    {Object.is(status, "importing") && (
      <CancelEmployeeImportActionIcon id={id} />
    )}

    {Object.is(status, "processed") && (
      <>
        <ImportEmployeeDataActionIcon id={id} />
        <CancelEmployeeImportActionIcon id={id} />
        <DownloadEmployeeDataFileActionIcon id={id} />
      </>
    )}

    {Object.is(status, "imported") && (
      <>
        <CircleCheck size={18} color="#868e96" />

        <CircleX size={18} color="#868e96" />

        <DownloadEmployeeDataFileActionIcon id={id} />
      </>
    )}
  </Group>
);

export default EmployeeDataImportTableMenu;
